import React from 'react';
import { themes } from '../types';

interface PomodoroProgressProps {
    currentSet: number;
    theme: typeof themes[keyof typeof themes];
}

export function PomodoroProgress({ currentSet, theme }: PomodoroProgressProps) {
    return (
        <div className="flex gap-2 justify-center">
            {[1, 2, 3, 4].map((set) => (
                <div
                    key={set}
                    className={`h-2 w-16 rounded-full transition-all duration-300 ${set <= currentSet
                        ? currentSet === set
                            ? `${theme.primary.split(' ')[0]} animate-pulse`
                            : theme.primary
                        : theme.secondary
                        }`}
                />
            ))}
        </div>
    );
}
